// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/menu-salle.scss
// module id = 1
// module chunks = 0 2